
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import {
  IFlexMessageBox,
  IFlexMessageBubble,
  IFlexMessageButton,
  IFlexMessageCarousel, IFlexMessageFiller, IFlexMessageIcon, IFlexMessageImage, IFlexMessageSeparator,
  IFlexMessageSpan, IFlexMessageText, IFlexMessageVideo,
} from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['onSelectNode', 'onHoverNode'],
})
export default class Span extends Vue {
  @Prop()
  span!: IFlexMessageSpan

  @Prop()
  selectedNode!: IFlexMessageCarousel | IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo

  @Prop()
  selectedPath!: string

  @Prop()
  parentPath!: string

  @Prop()
  errorPath!: string[]

  isHover = false

  selectNode(node, path) {
    if (this.selectedNode === node && this.selectedPath === path) {
      this.$emit('onSelectNode', undefined, '')
    } else {
      this.$emit('onSelectNode', node, path)
    }
  }

  @Watch('isHover')
  onHover() {
    if (this.isHover) {
      this.$emit('onHoverNode', this.parentPath + 'span')
    }
  }
}
